module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/corporate.json
// module id = 733
// module chunks = 69724295403194